<h1 class="mb-2"><mdb-icon fas icon="tasks"></mdb-icon> Cotización</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Ventas</span>
      <span> /</span>
      <span>Cotización</span>
    </p>
  </div>
</div>
<!-- Heading -->

<app-cotizacion-cabecera></app-cotizacion-cabecera>

<app-cotizacion-detalle></app-cotizacion-detalle>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <button
      mdbBtn
      type="button"
      color="success"
      (click)="enviarEmail.show()"
      mdbWavesEffect
    >
      Imprimir
    </button>
    <button
      mdbBtn
      type="button"
      color="success"
      (click)="enviarEmail.show()"
      mdbWavesEffect
    >
      Guardar
    </button>
  </div>
</div>

<!-- MODAL enviarEmail -->
<div
  mdbModal
  #enviarEmail="mdb-modal"
  class="modal fade"
  id="basicExample"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Información
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="enviarEmail.hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <h5>Se ha generado exitosamente la COT Nro. XXX</h5>
        <h5>¿ Desea enviarla al Email registrado ?</h5>
      </div>
      <div class="modal-footer justify-content-between">
        <button
          type="button"
          class="btn btn-default waves-light"
          data-dismiss="modal"
          (click)="enviarEmail.hide()"
          mdbWavesEffect
        >
          No
        </button>
        <button
          type="button"
          class="btn btn-success waves-light"
          data-dismiss="modal"
          (click)="enviarEmail.hide()"
          mdbWavesEffect
        >
          Si
        </button>
      </div>
    </div>
  </div>
</div>
